var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formattedMessage)?_c(_vm.countdownComponent,{tag:"component",staticClass:"re-countdown"},[_vm._t("default",function(){return [_c('p',{domProps:{"innerHTML":_vm._s(_vm.formattedMessage)}})]},null,_vm.slotAttrs)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }